// #region imports

// --- HS Code
import { CommandOfT } from "../shared/command";
import { GroupModel } from "./group-model";

// #endregion

export class DeleteGroupCommand implements CommandOfT<GroupModel[]> {
  private _isExecuted: boolean;

  private readonly _deletedGroup: GroupModel;
  private readonly _groups: GroupModel[];
  private readonly _deletedGroupIndex: number;

  get groups(): GroupModel[] {
    if (!this._isExecuted) throw new Error('The command has not yet been executed. No changes have been affected!');
    return this._groups;
  }

  constructor(group: GroupModel, groups: GroupModel[]) {
    this._isExecuted = false;
    this._deletedGroup = group;
    this._deletedGroupIndex = group.index;
    this._groups = groups;
  }

  execute(): GroupModel[] {
    if (this._isExecuted) return this._groups;

    const groupsIndex = this._groups.findIndex(g => g.id.toLowerCase() === this._deletedGroup.id.toLowerCase());
    if (groupsIndex < 0) return this._groups;

    this._isExecuted = true;

    this._groups.splice(groupsIndex, 1);
    this._groups.forEach(g => {
      if (g.index > this._deletedGroupIndex) g.index--;
    });

    return this._groups;
  }

  undo(): GroupModel[] {
    if (!this._isExecuted) return this._groups;

    const groupsIndex = this._deletedGroupIndex - 1;
    this._groups.forEach(g => {
      if (g.index >= this._deletedGroupIndex) g.index++;
    })

    this._groups.splice(groupsIndex, 0, this._deletedGroup);
    return this._groups;
  }
}
